import { ResumeViewer } from "./ResumeViewer";

export default function Resume() {
  return <ResumeViewer />;
}
